module.exports = __webpack_public_path__ + "img/cognitive_img01.15bf4a94.png";